import { ILaya } from "../../ILaya";
import { LayaEnv } from "../../LayaEnv";
import { NodeFlags } from "../Const";
import { Pool } from "../utils/Pool";
export class Component {
    get hideFlags() {
        return this._hideFlags;
    }
    set hideFlags(value) {
        this._hideFlags = value;
    }
    constructor() {
        var _a;
        this._hideFlags = 0;
        this._status = 0;
        this._enabled = true;
        this._id = _idCounter++;
        this._singleton = (_a = Object.getPrototypeOf(this)._$singleton) !== null && _a !== void 0 ? _a : true;
        this._initialize();
    }
    _initialize() {
        this._extra = {};
    }
    hasHideFlag(flag) {
        return (this._hideFlags & flag) != 0;
    }
    get id() {
        return this._id;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled != value) {
            this._enabled = value;
            if (this.owner)
                this._setActive(value && this.owner.activeInHierarchy);
        }
    }
    get awaked() {
        return this._status > 0;
    }
    get destroyed() {
        return this._status == 4;
    }
    _isScript() {
        return false;
    }
    _resetComp() {
        this._enabled = true;
        this._status = 0;
        this._enableState = false;
        this.owner = null;
    }
    _setOwner(node) {
        if (this._status != 0) {
            throw new Error('reuse a destroyed component');
        }
        this.owner = node;
        if (this._isScript())
            node._setBit(NodeFlags.HAS_SCRIPT, true);
        this._onAdded();
        this.onAdded();
    }
    _onAdded() {
    }
    _onAwake() {
    }
    _onEnable() {
        this.onEnable();
    }
    _onDisable() {
        this.onDisable();
    }
    _onDestroy() {
    }
    _parse(data, interactMap = null) {
    }
    _parseInteractive(data = null, spriteMap = null) {
    }
    _cloneTo(dest) {
    }
    _setActive(value) {
        var _a;
        if (value) {
            if (this._status == 0) {
                this._status = 1;
                if (LayaEnv.isPlaying || this.runInEditor) {
                    this._onAwake();
                    this.onAwake();
                }
            }
            if (this._enabled && !this._enableState) {
                this._enableState = true;
                if (LayaEnv.isPlaying || this.runInEditor) {
                    this._driver = ((_a = this.owner._scene) === null || _a === void 0 ? void 0 : _a._componentDriver) || ILaya.stage._componentDriver;
                    this._driver.add(this);
                    if (LayaEnv.isPlaying && this._isScript())
                        this.setupScript();
                    this._onEnable();
                }
            }
        }
        else if (this._enableState) {
            this._enableState = false;
            if (LayaEnv.isPlaying || this.runInEditor) {
                if (this._driver)
                    this._driver.remove(this);
                ILaya.stage.offAllCaller(this);
                this._onDisable();
            }
        }
    }
    setupScript() {
    }
    destroy() {
        if (this._status == 4)
            return;
        if (this.owner)
            this.owner._destroyComponent(this);
        else if (!this.destroyed)
            this._destroy(true);
    }
    _destroy(second) {
        if (second) {
            if (LayaEnv.isPlaying || this.runInEditor) {
                this._onDestroy();
                this.onDestroy();
                if (this.onReset) {
                    this.onReset();
                    this._resetComp();
                    Pool.recoverByClass(this);
                }
            }
            return;
        }
        this._setActive(false);
        this._status = 4;
        if (LayaEnv.isPlaying || this.runInEditor)
            (this._driver || ILaya.stage._componentDriver)._toDestroys.add(this);
        this._driver = null;
    }
    onAdded() {
    }
    onAwake() {
    }
    onEnable() {
    }
    onDisable() {
    }
    onDestroy() {
    }
}
var _idCounter = 0;
